import {
    singleEmailReminderSummary,
    multipleEmailRemindersSummary,
} from '../strings.locstring.json';
import loc, { format } from 'owa-localize';
import getFilteredInboxReminders from '../utils/getFilteredInboxReminders';
import InboxReminderType from 'owa-service/lib/contract/InboxReminderType';

export default function getEmailReminderSummaryText(inboxReminders: InboxReminderType[]): string {
    const remindersToShow = getFilteredInboxReminders(inboxReminders);

    return remindersToShow.length > 1
        ? format(loc(multipleEmailRemindersSummary), remindersToShow.length)
        : loc(singleEmailReminderSummary);
}
